
export const pageTitleDefault = `Citizen Music | An exceptional production music library for advertising`;
export const pageTitleAbout = `Citizen Music About | Why we're crafting exceptional music for advertising`;

export const COLOR_ORANGE = '#ff7837';
export const COLOR_CREAM = '#ede3d6';


// WEBPACK FOOTER //
// ./src/constants.js